import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import Popover from 'components/popover/Popover';
import DepartmentActions from 'actions/DepartmentActions';
import AccountActions from 'actions/AccountActions';

class SidebarCoworkers extends React.Component {
  constructor(props) {
    super(props);

    this.onCoreAccountData = this.onCoreAccountData.bind(this);
    this.onScheduleData = this.onScheduleData.bind(this);
    this.onDepartmentSelect = this.onDepartmentSelect.bind(this);
    this.getDepartmentSchedule = this.getDepartmentSchedule.bind(this);
    this.toggleDepartmentMenu = this.toggleDepartmentMenu.bind(this);

    this.state = {
      schedule: [],
      sortedDepartments: [],
      department: null,
      popOverActive: false,
      popTarget: null,
      loaded: false,
    }
  }

  componentWillMount() {
    this.onCoreAccountData();
    AccountActions.getCoreAccount();
    AccountStore.on('core:account:load:success', this.onCoreAccountData);
    DepartmentsStore.on('schedule:load:success', this.onScheduleData);
  }

  componentWillUnmount() {
    AccountStore.off('core:account:load:success', this.onCoreAccountData);
    DepartmentsStore.off('schedule:load:success', this.onScheduleData);
  }

  onCoreAccountData() {
    const sorted = _.sortBy(AccountStore.coreAccount.departments, (department) => department.name.toLowerCase())
    this.setState(
      {
        department: sorted[0],
        sortedDepartments: sorted,
      },
      this.getDepartmentSchedule
    );
  }

  onScheduleData(_data, response) {
    // Filter out current user and map the data we need
    let schedule = response.data.scheduled_shifts
      .filter((shift) => shift.user_id !== AccountStore.coreAccount.id)
      .map((shift) => ({
        id: shift.id,
        name: response.data.user.filter((user) => user.id === shift.user_id)[0].name,
        position: shift.position,
        job_site_name: shift.job_site_name,
        start_time: moment(shift.start_time).tz(shift.time_zone).format('h:mm a'),
        end_time: moment(shift.end_time).tz(shift.time_zone).format('h:mm a'),
      }));

    // Sort by alpha, by end time, and then by start time
    const selectedDate = `${moment(this.props.selectedDate).format('MM/DD/YYYY')} `;
    schedule = _.sortBy(schedule, (coworker) => coworker.name.toLowerCase());
    schedule = _.sortBy(schedule, (coworker) => new Date(selectedDate + coworker.end_time).valueOf());
    schedule = _.sortBy(schedule, (coworker) => new Date(selectedDate + coworker.start_time).valueOf());

    this.setState({ schedule, loaded: true });
  }

  onDepartmentSelect(department) {
    this.setState(
      {
        department,
        popOverActive: false,
        popTarget: null,
      },
      this.getDepartmentSchedule
    );
  }

  getDepartmentSchedule() {
    const selectedDate = moment(this.props.selectedDate).format('YYYY-MM-DD');
    const departmentID = this.state.department.id;
    DepartmentActions.getDepartmentSchedule(departmentID, selectedDate, selectedDate);
    this.setState({ loaded: false });
  }

  toggleDepartmentMenu() {
    this.setState({
      popOverActive: !this.state.popOverActive,
      popTarget: !this.state.popOverActive ? ReactDOM.findDOMNode(this).querySelector('#department-button') : null,
    });
  }

  render() {
    return (
      <div className="coworkers">
        <div className="coworkers-header">
          <h3>{this.state.department.name}</h3>
          {this.state.sortedDepartments && this.state.sortedDepartments.length > 1 &&
            <a
              id="department-button"
              onClick={this.toggleDepartmentMenu}
            >
              {this.props.t('SidebarCoworkers.department')}
            </a>
          }
        </div>
        <Popover
          position="top"
          className="department-menu"
          onHide={this.toggleDepartmentMenu}
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <ul>
            {this.state.department &&
            this.state.sortedDepartments.map((department, index) => (
              <li
                key={index}
                className={this.state.department.id === department.id ? 'disabled' : ''}
                onClick={this.state.department.id === department.id ? null : () => this.onDepartmentSelect(department)}
              >
                <a>{department.name}</a>
              </li>
            ))}
          </ul>
        </Popover>
        {this.state.schedule.map((coworker) => (
          <div key={coworker.id} className="calendar-input coworkers-details">
            <h3>{coworker.name}</h3>
            <p>{coworker.job_site_name}</p>
            <p>{coworker.start_time} - {coworker.end_time}</p>
            <p>{coworker.position}</p>
          </div>
        ))}
        {this.state.loaded && this.state.schedule.length === 0 &&
          <div className="calendar-input select-a-day">
            <span>
              <img alt="calendar icon" src="images/pngs/my-shift.png" />
            </span>
            <p>{this.props.t('SidebarCoworkers.no_employees')}</p>
          </div>
        }
      </div>
    );
  }
}

export default translate()(SidebarCoworkers);
